import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth uses httpOnly cookies — send credentials on every request from this instance.
export const api = axios.create({ baseURL: API, withCredentials: true });

export { API };
